import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getToken } from "../../Libs/Utils/Auth";

const NotLoggedInRoute = ({
  component: Component,
  children,
  render,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (!getToken()) {
        if (Component) {
          return <Component {...props} />;
        }
        if (render) {
          return render(...props);
        }
        return children;
      }
      return (
        <Redirect
          to={{
            pathname: "/home",
          }}
        />
      );
    }}
  />
);

export default NotLoggedInRoute;
